import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';


import { HeaderPageRoutingModule } from './header-routing.module';

import { HeaderPage } from './header.page';
import { MenuPage } from '../menu/menu.page';
import { TranslateModule } from '@ngx-translate/core';
import { ModalPageModule } from '../modal/modal.module';
import { LogoutDialogPageModule } from '../shared/logout-dialog/logout-dialog.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HeaderPageRoutingModule,
    TranslateModule,
    ModalPageModule,
    // O `LoginPageModule` NÃO entra aqui. O cabeçalho é eager (vem com o cardápio) e
    // importá-lo trazia login + cadastro + esqueci-a-senha para o bundle do boot — ~92 KB de
    // fonte para uma tela que a maioria das visitas nunca abre. O `goToLogin()` carrega a
    // página e o módulo dela no toque, via `carregarTelaDeLogin()` (shared/utils/lazy-login.ts).
    LogoutDialogPageModule,
  ],
  declarations: [HeaderPage],
  exports: [HeaderPage],
  providers: [MenuPage],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeaderPageModule {}
